import { ReactNode } from 'react'

export const UpgradeBanner = ({
  onUpgrade,
  upgradeText = 'Upgrade',
  children,
}: {
  children: ReactNode
  upgradeText?: string
  onUpgrade?: () => void
}) => {
  return (
    <div className="bg-indigo-600 text-basicPrimary-500 rounded-lg p-2 flex space-x-3 items-center">
      <div className="rounded-lg p-2 bg-indigo-800">
        <img
          src="/images/icons/upgrade-icon.svg"
          alt="Upgrade plan icon"
          className="w-6 h-6 flex-shrink-0"
        />
      </div>
      <div className="flex-grow">{children}</div>
      <a
        href="/admin/community/billing"
        onClick={e => {
          if (typeof onUpgrade === 'function') {
            e.preventDefault()
            onUpgrade()
          }
        }}
        className="font-semibold py-1.5 px-3 mx-2 rounded-lg hover:bg-indigo-700"
      >
        {upgradeText}
      </a>
    </div>
  )
}
